import { inject, Injectable } from '@angular/core';
import { ApiService } from 'shared-lib';
import { Observable, of, switchMap } from 'rxjs';
import { UserService } from '@selfCareCore/user';
import { SharedDataService } from './shared-data.service';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private readonly apiService = inject(ApiService);
  private readonly userService = inject(UserService);
  private readonly sharedDataService = inject(SharedDataService);

  getPaymentChannel(qParams: any): Observable<any> {
    return this.apiService.get('v1/superapp/payment-channel/self-care', qParams);
  }

  fetchfeatureVisibility(): Observable<any> {
    return this.apiService.get('v1/superapp/home-feature-visibility-configuration', { platformKey: 'WEB_SELF_CARE' });
  }

  getLinkedAccounts(qParams?: any): Observable<any> {
    const customerCode = this.userService.user().username;
    return this.apiService.get(`v1/superapp/customer-link-account/linked-accounts/${customerCode}`, qParams);
  }

  uploadPrivateFile(data: any): Observable<any> {
    return this.apiService.fileUploadPost('v1/superapp/file/save/private', data);
  }

  uploadPublicFile(data: any): Observable<any> {
    return this.apiService.fileUploadPost('v1/superapp/file/save/public', data);
  }

  getBalance(): Observable<number> {
    return this.apiService.get<number>('v1/superapp/transaction/balance').pipe(
      switchMap((balance) => {
        this.sharedDataService.setBalance(balance);
        return of(balance);
      })
    );
  }
}
